module.exports = __webpack_public_path__ + "img/welcome.874454ba.gif";